/*时间戳格式转成yy-mm-dd dd:mm:ss格式的处理*/
export function timeConvert(timestamp) {
	var d = new Date(timestamp);
	var year = d.getFullYear();
	var month = d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1);
	var date = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
	var hour = d.getHours() >= 10 ? d.getHours() : '0' + d.getHours();
	var minute = d.getMinutes() >= 10 ? d.getMinutes() : '0' + d.getMinutes();
	var second = d.getSeconds() >= 10 ? d.getSeconds() : '0' + d.getSeconds();
	timestamp = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
	return timestamp

}
export default {
	timeConvert
}


//////////////////
// WEBPACK FOOTER
// ./static/js/timeyymmddmmss.js
// module id = F6wd
// module chunks = 0